<!--
 * @Name: 优惠券
 * @CreateDate: 2020-07-30
-->
<template>
  <div class="coupons-c" :style="{ width, height }" @click="getCoupon">

    <!-- 驾校优惠券 -->
    <div class="coupons" disable
         :class="{'opacityp5': hasOpacity,'st-coupons':couponsData.type==1,'platform-coupons':couponsData.type==2,'overdue-coupons': couponsData.is_expired}"
    >
      <div class="left">{{ couponsData.short_name || '学车立减' }}</div>
      <div class="mid">
        <div class="st-name" v-if="couponsData.type==1">{{ couponsData.store_name.length >= 10 ? couponsData.store_name.slice(0,10) + '...' : couponsData.store_name }}
			<!-- <div class="region-class">{{couponsData.district_name.length >= 3 ? couponsData.district_name.slice(0,3)+ '...' : couponsData.district_name}}</div> -->
		</div>
        <div class="st-name" v-if="couponsData.type==2">平台优惠券</div>
        <div class="desc">
          <span class="money">{{ couponsData.face_value }}</span>
          <span class="unit">元</span>
          <span>学费立减券</span>
        </div>
      </div>


     <template v-if="couponsData.is_buy">
        <div class="free" v-if="couponsData.vr_state==2" >已过期</div>
        <div class="free" v-else-if="couponsData.is_use" >已使用</div>
        <div class="free" v-else @click="toUse(couponsData.order_id)">去使用</div>
      </template>

      <template v-if="!couponsData.is_buy && couponsData.price <= 0">
        <div class="free" style="font-size: 16px;" v-if="!couponsData.is_buy && couponsData.price <=0" @click="getCoupon">免费领取</div>
      </template>

      <template v-if="!couponsData.is_buy && couponsData.price > 0">
        <div class="price free" v-if="isClick" @click="getCoupon" style="font-size: 16px;">
          立即购买
        </div>
        <div class="price" v-else>￥{{couponsData.price}}</div>
      </template>
      <nut-checkbox v-if="isOptional" v-model="optional" size="small" class="my-checkbox"
                    @change="getChange"></nut-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Coupons',
  props: {
    width: {
      type: String,
      default: '277px',
    },
    height: {
      type: String,
      default: '80px',
    },
    //1 驾校, 2平台(活动)
    couponsTab: {type: Number},
    /**
     * 字段说明
     * type: 优惠券类型,  1:驾校 ;  2:活动平台
     * is_use: 是否已经使用
     * is_expired: 是否过期
     * short_name: 优惠券简称
     * store_name: 驾校名称
     * face_value: 优惠券面值
     * is_buy : 是否购买了
     * price:    优惠券价格, <=0 显示免费,收集用户信息
     */
    couponsData: {type: Object, required: false}, // 优惠券数据
    isOptional: {
      type: Boolean,
      required: false,
      default: false
    }, //是否可以选中
    dftOptional: {
      type: Boolean,
      required: false,
      default: false
    }, //是否默认选中
    hasOpacity: {
      type: Boolean,
      required: false,
      default: false
    }, //是否显示阴影
    isClick: {
      type: Boolean,
      required: false,
      default: false
    } //是否可以点击
  },
  data: () => ({
    optional: false //是否选中
  }),
  watch: {
    dftOptional(newVal, oldVal) {
      this.optional = newVal;
    }
  },
  methods: {
    getCoupon() {
      if (this.isClick || !this.couponsData.is_buy) {
        this.$emit('getCoupon',this.couponsData);
      }
    },
    /**
     * 单选值变化时
     * @param {Boolean} checked - 选择状态
     * @param {number} val - 选中值
     */
    getChange(checked, val) {
      this.$emit('getChange', this.couponsData.id);
    },
    /**
     * 使用优惠券
     * @param {number} id - 优惠券id
     */
    toUse(id) {
        this.$router.push({name: 'ODOngoing', query: {id: id}});
	},
	routerSchoolDetail(store_id) {
		this.$router.push({name: 'StDetail', query: {id: store_id}});
	}
  },
  mounted() {
	this.optional = this.dftOptional;
	if (this.couponsData && (this.couponsData.is_use_type == 1 || this.couponsData.is_use_type == 3)) {
		this.hasOpacity = true;
	}
  }
}
</script>

<style lang="less" scoped>
.coupons-c {
	.coupons {
		width: 100%;
		height: 100%;
		background-image: url(../assets/images/coupons_bg.png);
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 2.527076%;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
		position: relative;

		.left {
			width: 5.776173%;
			height: 100%;
			writing-mode: vertical-lr;
			font-size: 12px;
			font-weight: bold;
			color: #ff4c4a;
			line-height: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.mid {
			width: 50%;
			height: 100%;
			box-sizing: border-box;
			padding-left: 3.610108%;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			color: #fff;

			.st-name {
				height: 40%;
				display: flex;
				align-items: center;
				font-size: 14px;
				.region-class {
					position: absolute;
					right: 30%;
				}
			}

			.desc {
				height: 60%;
				display: flex;
				align-items: center;

				span {
					font-size: 12px;
				}

				.money {
					font-size: 20px;
					font-weight: bold;
					margin-right: 5px;
				}

				.unit {
					margin-right: 5px;
				}
			}
		}

		.free {
			width: 25.99278%;
			text-align: center;
			font-weight: bold;
			color: #ff8207;
			writing-mode: vertical-lr;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			line-height: 16px;
		}

		.price {
			width: 25.99278%;
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			color: #ff8207;
		}

		.my-checkbox {
			position: absolute;
			top: 0px;
			right: 0px;
		}
	}

	.platform-coupons {
		background-image: url(../assets/images/coupons_bg_1.png);

		.left {
			color: #ff2e50;
		}

		.free {
			font-size: 14px;
			color: #ff2e50;
			writing-mode: vertical-lr;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 16px;
		}

		.price {
			color: #ff4a4d;

			em {
				font-style: normal;
				font-size: 12px;
			}
		}
	}

	.opacityp5 {
		opacity: 0.5;
	}
}
.coupons-c {
	.coupons {
		width: 100%;
		height: 100%;
		background-color: #f8f8f8;
		background-image: url(../assets/images/coupons_bg.png);
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 2.527076%;
		box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
		position: relative;
		.left {
			width: 5.776173%;
			height: 100%;
			writing-mode: vertical-lr;
			font-size: 12px;
			font-weight: bold;
			color: #ff4c4a;
			line-height: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.mid {
			width: 50%;
			height: 100%;
			box-sizing: border-box;
			padding-left: 3.610108%;
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			color: #fff;
			.st-name {
				height: 40%;
				display: flex;
				align-items: center;
				font-size: 14px;
			}
			.desc {
				height: 60%;
				display: flex;
				align-items: center;
				span {
					font-size: 12px;
				}
				.money {
					font-size: 20px;
					font-weight: bold;
					margin-right: 5px;
				}
				.unit {
					margin-right: 5px;
				}
			}
		}
		.free {
			width: 25.99278%;
			text-align: center;
			font-weight: bold;
			color: #ff8207;
			writing-mode: vertical-lr;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			line-height: 16px;
		}
		.price {
			width: 25.99278%;
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			color: #ff8207;
		}
		.my-checkbox {
			position: absolute;
			top: 0px;
			right: 0px;
		}
	}
	.platform-coupons {
		background-image: url(../assets/images/coupons_bg_1.png);
		.left {
			color: #ff2e50;
		}
		.free {
			font-size: 14px;
			color: #ff2e50;
			writing-mode: vertical-lr;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 16px;
		}
		.price {
			color: #ff4a4d;
			em {
				font-style: normal;
				font-size: 12px;
			}
		}
	}
	.overdue-coupons {
		background-image: url(../assets/images/coupons_bg_2.png);
		.left {
			color: #fff;
		}
		.mid {
			color: #a9adb4;
		}
		.free {
			font-size: 14px;
			color: #a9adb4;
			writing-mode: vertical-lr;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 16px;
		}
	}
	.opacityp5 {
		opacity: 0.5;
	}
}

/deep/ .nut-checkbox.nut-checkbox-size-small input {
	width: 12px;
	height: 12px;
}
/deep/ .nut-checkbox input {
	border-radius: 50%;
}
/deep/ .nut-checkbox input:checked {
	background-image: url(../assets/images/check-icon.png);
	background-color: #3c43ec;
	border-color: #3c43ec;
	background-size: 100%;
}
</style>
